import { render } from "./appEduResearch.vue?vue&type=template&id=41f92d45&scoped=true"
import script from "./appEduResearch.vue?vue&type=script&lang=js"
export * from "./appEduResearch.vue?vue&type=script&lang=js"

import "./appEduResearch.vue?vue&type=style&index=0&id=41f92d45&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f92d45"]])

export default __exports__